module.exports = __webpack_public_path__ + "static/media/security.a2ebb25b.svg";